import React from "react";
import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../data/entrepminds";

const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-12 gap-12 items-end mb-14"
        >
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-4">How we work</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05]">
              <span className="gold-text">Diagnose.</span> Optimize.
              <br />
              Automate. <span className="gold-text">Scale.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-[#6b6356] text-base md:text-lg leading-relaxed">
            A four-step loop, repeated until your business runs itself. Each phase is
            measurable, implementation-first, and tied to commercial outcomes.
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_STEPS.map((step, idx) => {
            const Icon = step.Icon;
            return (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.08 }}
                data-testid={`process-${step.title.toLowerCase()}`}
                className="em-card p-7 relative overflow-hidden"
              >
                <div className="absolute top-5 right-5 font-mono-em text-[11px] text-[#9a9180] tracking-[0.25em]">
                  0{idx + 1}
                </div>
                <div className="w-12 h-12 rounded-xl bg-[#d4af37]/15 border border-[#d4af37]/45 flex items-center justify-center mb-5">
                  <Icon size={20} className="text-[#8a6a10]" />
                </div>
                <h3 className="font-display text-2xl mb-2">{step.title}</h3>
                <p className="text-sm text-[#6b6356] leading-relaxed">{step.desc}</p>
                {idx < PROCESS_STEPS.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-[#d4af37]/40 to-transparent" />
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
